import { useCallback } from 'react';
import { useStockParameters } from '../useCustomerCatalogueService';

export const useValidateStockParameters = () => {
  const { stockParameters } = useStockParameters();

  return useCallback<() => string>(() => {
    if (!stockParameters.numberOfEmployees) {
      return 'You must set the number of employees before proceeding.';
    }

    return '';
  }, [stockParameters]);
};
